export default "__VITE_ASSET__DIx5dL1L__"